import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // default breakpoints in case we want to amend them
  // we can also define our own breakpoints name: size
  breakpoints: {
    values: {
      // mobile: 0,
      // tablet: 640,
      // laptop: 1024,
      // desktop: 1200,
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Verdana',
      'Tahoma',
      'Geneva',
      'sans-serif',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  palette: {
    primary: {
      // 3XD White
      light: '#ffffff',
      // 3XD Dark Blue
      main: '#394174',
      // 3XD Black
      dark: '#000000',
      // 3XD Contrast Text - Silver/grey 
      contrastText: '#bfc0c1',
    },
    secondary: {
      // 3XD Light Green
      light: '#39b54a',
      // 3XD Red
      main: '#d9534f',
      // 3XD - spare 
      dark: '#000000',
      // 3XD - light grey
      contrastText: '#d3d3d3',
    },
    background: {
      // default: '#394174',
      default: '#FFFFFF',
    },
  },
  mixins: {
    toolbar: {
      minHeight: '81px',
    }
  },
});

export default theme;